import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ParentWalletTransaction {
  _id: string;
  parentId: EntID;
  studioId: string;
  studentId?: EntID;
  transactionType: string;
  reason: string;
  paymentMethod?: string;
  amount: number;
  balance: number;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
  metadata?: Metadata;
}

export interface EntID {
  _id: string;
  firstName: string;
  lastName: string;
}

export interface Metadata {
  checkNumber?: string;
  paymentDate?: string;
  note?: string;
}

interface GetParentWalletTransactionsParams {
  parentId: string;
}

export const getParentWalletTransactions = async (
  params: GetParentWalletTransactionsParams,
) => {
  const response = await baseAPI.get<Array<ParentWalletTransaction>>(
    `parents/${params.parentId}/wallet-transactions`,
  );
  return response.data;
};

export const useGetParentWalletTransactions = (
  params: GetParentWalletTransactionsParams,
) => {
  return useQuery({
    queryKey: [KEYS.PARENT_WALLET_TRANSACTIONS, params.parentId],
    queryFn: () => getParentWalletTransactions(params),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
